module.exports = "<nav class=\"navigation\" ng-if=\"!isGroupLoading()\">\r\n    <h2 class=\"sr-only\">Product Group Navigation</h2>\r\n\r\n    <a class=\"navigation-link is-active\" ui-sref=\".\" ui-sref-opts=\"{ reload: true }\">\r\n        <span>\r\n            {{ productGroupName() }}\r\n            <span ng-if=\"!isCountLoading()\">({{ productsCount() }})</span>\r\n        </span>\r\n    </a>\r\n</nav>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/productgroups/productgroup.directive.html
// module id = 432
// module chunks = 0